import {
  createHsaSessionInput,
  createHsaSessionOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/create-hsa-session";
import { unaryRpc } from "@redotech/rpc/definition";

// Endpoint called when the shopper enters the HSA/FSA flow. Mints a new
// session and returns the public token UUID — that token becomes the URL
// capability for the customer-portal questionnaire (`/hsa/<sessionToken>`)
// or the cart-attribute capability for the storefront PDP modal.
//
// The input/output zod schemas live in
// `@redotech/redo-conversion-hsa-common/rpc-schemas/create-hsa-session` so
// the Shopify SDK can wrap the same contract with its own `unaryRpc` for
// the storefront entry point.
export const createHsaSession = unaryRpc({
  name: "createHsaSession",
  input: createHsaSessionInput,
  output: createHsaSessionOutput,
});
